import { Input, ModalProps, Select, Typography } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { useState } from 'react';
import { RxCross2 } from 'react-icons/rx';
import { useAppDispatch, useAppSelector } from 'src/redux/hook';
import { resetModalState } from 'src/redux/slice/modal.store';
import { TransactionHistory } from 'src/shared/interface/localpay.interface';
import { convertNumberByUnit, formatDateTime } from 'src/utils';
interface IOrderDetailModalProps extends ModalProps {
  selectedHistory?: TransactionHistory;
}
const OrderDetailModal = ({ selectedHistory }: IOrderDetailModalProps) => {
  const [capacityVal, setCapacityVal] = useState<string>();
  const { customer_name } = useAppSelector((state) => state.userProfile.dataEnterprise);
  const dispatch = useAppDispatch();
  return (
    <>
      <div className='relative flex flex-col gap-3'>
        <div className='flex absolute -top-2 -right-2'>
          <button
            onClick={() => dispatch(resetModalState())}
            className='flex items-center text-xl cursor-pointer border-transparent bg-transparent'
          >
            <RxCross2 />
          </button>
        </div>
        <div className='flex gap-5'>
          <div className='flex flex-col gap-1'>
            <Typography.Text>Mã tài khoản Data</Typography.Text>
            <Input readOnly value={selectedHistory?.extraDataObject.destinationPayAccountData} />
          </div>
          <div className='flex flex-col gap-1 flex-1'>
            <Typography.Text>Mã đơn hàng</Typography.Text>
            <Input readOnly value={selectedHistory?.paymentId} />
          </div>
        </div>
        <div className='flex flex-col gap-1'>
          <Typography.Text>Doanh nghiệp</Typography.Text>
          <Select
            showArrow
            defaultValue={''}
            disabled
            options={[
              {
                label: customer_name ?? '',
                value: '',
              },
            ]}
          ></Select>
        </div>
        <div className='flex gap-4'>
          <div className='flex items-end gap-3'>
            <div className='flex flex-col gap-1'>
              <Typography.Text>Dung lượng </Typography.Text>
              <Input
                readOnly
                value={
                  capacityVal
                    ? capacityVal
                    : convertNumberByUnit(
                        selectedHistory?.extraDataObject.totalData || 0,
                        'KB',
                        'GB',
                      )
                }
              />
            </div>
            <Select
              showArrow
              defaultValue={'GB'}
              className='min-w-[70px]'
              onChange={(ev) => {
                const value = convertNumberByUnit(
                  selectedHistory?.extraDataObject.totalData || 0,
                  'KB',
                  ev,
                );
                setCapacityVal(value);
              }}
              options={[
                {
                  label: 'KB',
                  value: 'KB',
                },
                {
                  label: 'MB',
                  value: 'MB',
                },
                {
                  label: 'GB',
                  value: 'GB',
                },
                {
                  label: 'TB',
                  value: 'TB',
                },
              ]}
            ></Select>
          </div>
          <div className='flex flex-col gap-1'>
            <Typography.Text>Dung lượng (KB)</Typography.Text>
            <Input
              readOnly
              value={convertNumberByUnit(
                selectedHistory?.extraDataObject.totalData || 0,
                'KB',
                'KB',
              )}
            />
          </div>
        </div>
        <div className='flex justify-between gap-4'>
          <div className='flex flex-col flex-1 gap-1'>
            <Typography.Text>Nội dung</Typography.Text>
            <TextArea readOnly value={selectedHistory?.extraDataObject.note} />
          </div>
          <div className='flex flex-col flex-1 gap-1'>
            <Typography.Text>Mã tham chiếu</Typography.Text>
            <Input readOnly value={selectedHistory?.extraDataObject.referenceId} />
          </div>
        </div>
        <div className='flex flex-col gap-2'>
          <Typography.Text>Người tạo: {selectedHistory?.createdBy}</Typography.Text>
          <Typography.Text>
            Thời gian tạo:{' '}
            {selectedHistory?.createdAt ? formatDateTime(selectedHistory?.createdAt) : ''}
          </Typography.Text>
        </div>
      </div>
    </>
  );
};
export default OrderDetailModal;
